import { Trans, useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { MODULE_NAME } from 'modules/Account/strings'
import { formatDate } from 'shared/utils'
import { IMPORT_DATE_FORMAT, paths } from 'config'
import {
  Card,
  InfoContainer,
  Highlight,
  PaymentDateContainer,
  Bold,
  DaysLeftContainer,
  ButtonsContainer,
  Button,
  EndsToday,
  Link,
} from './SubscriptionDetails.style'

const ID_PREFIX = 'account-subscription'

interface SubscriptionDetailsProps {
  daysLeft: number
  nextPaymentDate: string | Date
}

const SubscriptionDetails = ({
  daysLeft,
  nextPaymentDate,
  ...props
}: SubscriptionDetailsProps) => {
  const { t } = useTranslation(MODULE_NAME)
  const history = useHistory()

  const handleRedirect = () => history.replace(paths.subscription)

  const title = daysLeft ? (
    <Trans
      i18nKey={t('subscription.days', { count: daysLeft })}
      components={{ highlight: <Highlight /> }}
    />
  ) : (
    <EndsToday>
      {t('subscription.endsToday.title', { count: daysLeft })}
    </EndsToday>
  )

  const description = daysLeft ? (
    <Trans
      i18nKey={t('subscription.nextPaymentDate', {
        date: formatDate(nextPaymentDate, IMPORT_DATE_FORMAT),
      })}
      components={{ bold: <Bold /> }}
    />
  ) : (
    <Trans
      t={t}
      i18nKey={'subscription.endsToday.descriptionDefault'}
      components={{ highlight: <Link href={paths.subscription} /> }}
    />
  )

  return (
    <Card {...props}>
      <InfoContainer>
        <DaysLeftContainer>{title}</DaysLeftContainer>
        <PaymentDateContainer>{description}</PaymentDateContainer>
        {!!daysLeft && (
          <ButtonsContainer>
            <Button
              id={`${ID_PREFIX}-details-btn`}
              variant="outlined"
              onClick={handleRedirect}
            >
              {t('subscription.subscriptionDetails')}
            </Button>
          </ButtonsContainer>
        )}
      </InfoContainer>
    </Card>
  )
}

export default SubscriptionDetails
